import X2JS from 'x2js';

/* eslint-disable no-console */
const DevLog = console.log.bind(null) ;
const DevWarn = console.warn.bind(null) ;
const DevError = console.error.bind(null) ;

const yearStart = function () {
    return new Date(new Date().getFullYear(), 0, 1);
};
const dateEqual = function (d1, d2) {
    if (!d1 || !d2) {
        return !d1 && !d2;
    }
    return d1.getTime() === d2.getTime();
};
const getDueDateString = function (d) {
    const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    const difference = Math.abs(d.getTime() - new Date().getTime());
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    if (difference < oneDayInMilliseconds) {
        return "today";
    }
    else if (difference < 6 * oneDayInMilliseconds) {
        const dayOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][d.getDay()];
        return `on ${dayOfWeek}`;
    }
    else {
        return `on ${d.getDate()} ${monthNames[d.getMonth()]} ${d.getFullYear()}`;
    }
};
const getTimeFromNow = (dateStr) => {
    const date = new Date(dateStr);
    const currentDate = new Date();
    const diffInMs = currentDate.getTime() - date.getTime();
    const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
    if (diffInDays === 0) {
        return "Today";
    }
    else if (diffInDays === 1) {
        return "Yesterday";
    }
    else if (diffInDays <= 7) {
        return `${diffInDays} days ago`;
    }
    else {
        return date.toLocaleDateString(undefined, { month: "numeric", day: "numeric", year: "numeric" });
    }
};
function toDate(argument) {
    if (isDate$1(argument)) {
        return new Date(argument.getTime());
    }
    else if (typeof argument === "number") {
        return new Date(argument);
    }
    else {
        return new Date(NaN);
    }
}
function compareAsc(dateLeft, dateRight) {
    const _dateLeft = toDate(dateLeft);
    const _dateRight = toDate(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) {
        return -1;
    }
    else if (diff > 0) {
        return 1;
        // Return 0 if diff is 0; return NaN if diff is NaN
    }
    else {
        return diff;
    }
}
function isDate$1(value) {
    return (value instanceof Date ||
        (typeof value === "object" &&
            Object.prototype.toString.call(value) === "[object Date]"));
}

function isObject(object) {
    return object != null && typeof object === "object";
}
function isDate(d) {
    return d instanceof Date;
}
function deepCopy(obj, forceUTC = false) {
    const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/; //> may need Z on end
    //parse dates if json to js obj from string 
    const reviver = (_key, value) => {
        if (typeof value === "string" && dateFormat.test(value)) {
            if (forceUTC && !value.includes("Z")) { //> should investagate Z or +00:00
                value += "Z";
            }
            return new Date(value);
        }
        return value;
    };
    return JSON.parse(JSON.stringify(obj), reviver);
}
function deepEqual(object1, object2) {
    if (!object1 || !object2) {
        return object1 === object2;
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areDates = isDate(val1) && isDate(val2);
        const areObjects = isObject(val1) && isObject(val2);
        if ((areDates && !dateEqual(val1, val2)) ||
            (areObjects && !deepEqual(val1, val2)) ||
            (!areObjects && val1 !== val2)) {
            return false;
        }
    }
    return true;
}

//Get module in tree
//Default latest active, if request passed returns the matching module or undefined
const getModule = (course, request, includeUnavailable) => {
    const n = (modules) => {
        let module;
        modules.forEach(e => {
            if (module)
                return;
            if (e.type !== "section" && ((request && request.slug == e.slug && request.type == e.type)
                || (!request && !e.complete && (includeUnavailable || !e.availableFrom || e.availableFrom < new Date())))) {
                module = e;
                return;
            }
            else if (e.modules) {
                module = n(e.modules);
                if (module)
                    return;
            }
        });
        return module;
    };
    if (!course || !course.modules)
        return;
    return n(course?.modules);
};
//Get the first module in tree
const getFirstModule = (course) => {
    let module;
    const n = (modules) => {
        modules.forEach(e => {
            if (module)
                return;
            if (e.type !== "section") {
                module = e;
                return;
            }
            else if (e.modules)
                n(e.modules);
        });
        return module;
    };
    if (!course.modules)
        return;
    n(course?.modules);
    return module;
};
//Get the module straight after the requested module in tree
const getNextLinearModule = (course, request) => {
    let module;
    let grabNext = false;
    const n = (modules) => {
        modules.forEach(e => {
            if (module)
                return;
            if (grabNext && e.type !== "section") {
                module = e;
                return;
            }
            if (!grabNext && e.type !== "section" && request.slug == e.slug && request.type == e.type) {
                grabNext = true;
            }
            if (e.modules) {
                n(e.modules);
            }
        });
        return module;
    };
    if (!course.modules)
        return;
    n(course?.modules);
    return module;
};

const loadImage = (url) => new Promise((res, rej) => {
    const img = new Image();
    img.addEventListener("load", () => res(img));
    img.addEventListener("error", (err) => rej(err));
    img.src = url;
});
const buildPngFromSvg = async (src) => {
    const res = await fetch(src);
    const img = await res.text();
    const svgData = new Blob([img], { type: "image/svg+xml" });
    const DOMURL = window.URL || window.webkitURL || window;
    const b64str = DOMURL.createObjectURL(svgData);
    //CANVAS
    const mImg = await loadImage(b64str);
    const imgW = mImg.naturalWidth;
    const imgH = mImg.naturalHeight;
    const scale = window.devicePixelRatio * 2;
    const canv = document.createElement("canvas");
    canv.width = imgW;
    canv.height = imgH;
    const ctx = canv.getContext("2d");
    canv["style"]["width"] = `${Math.round(imgW / scale)}px`;
    canv["style"]["height"] = `${Math.round(imgH / scale)}px`;
    canv["style"]["margin"] = "0";
    canv["style"]["padding"] = "0";
    ctx?.scale(scale, scale);
    ctx?.drawImage(mImg, 0, 0, Math.round(imgW / scale), Math.round(imgH / scale));
    const imgSrc = canv.toDataURL();
    return imgSrc ? imgSrc : "";
};

const convertXmlToObject = (xmlData) => {
    const x2js = new X2JS();
    return x2js.xml2js(xmlData);
};
const fetchIMSManifest = async (url) => {
    const result = await fetch(url);
    const content = await result.text();
    return convertXmlToObject(content);
};
const getModuleURLFromIMSManifestContent = (imsmanifestUrl, content) => {
    try {
        // Extract the base URL
        const baseUrl = imsmanifestUrl.replace("imsmanifest.xml", "");
        if (!content?.manifest || !content.manifest.resources || !content.manifest.resources.resource) {
            throw new Error("Invalid manifest structure");
        }
        const resources = content.manifest.resources.resource;
        // Ensure that resources is an array, even if there's a single resource
        const resourcesArray = Array.isArray(resources) ? resources : [resources];
        // Find the resource with _type "webcontent" and get its _href
        const webContentResource = resourcesArray.find(resource => resource._type === "webcontent");
        if (webContentResource && webContentResource._href) {
            return baseUrl + webContentResource._href;
        }
        else {
            throw new Error("No webcontent resource found in manifest");
        }
    }
    catch (error) {
        console.error("[getModuleURLFromIMSManifestContent] Error parsing manifest content", error);
        return undefined;
    }
};

export { DevError, DevLog, DevWarn, buildPngFromSvg, compareAsc, dateEqual, deepCopy, deepEqual, fetchIMSManifest, getDueDateString, getFirstModule, getModule, getModuleURLFromIMSManifestContent, getNextLinearModule, getTimeFromNow, isDate$1 as isDate, toDate, yearStart };
